
import { 
  Card, 
  CardContent, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { OpportunityForm } from "@/components/opportunity/OpportunityForm";

export default function CreateOpportunity() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold tracking-tight">Create Opportunity</h1>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle>Opportunity Details</CardTitle>
        </CardHeader>
        <CardContent>
          <OpportunityForm />
        </CardContent>
      </Card>
    </div>
  );
}
